import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import LoadingSpinner from './LoadingSpinner';
import apiService from '../../../Auth/apiService';
import { useAuth } from '../../../Auth/AuthContext';
import { Mensaje } from '../../../services/mensajeService';
import { LoginBoxMsg, InputGroup, FormGroup, Button, StyledSelect, StyledInput, LockscreenFooter, ButtonLink, FormImage } from './../../Utils/StyledComponents';
import { Col, Row } from 'react-bootstrap';

const Logeando = withReactContent(Swal);

export default function AppLogin() {
    const navigate = useNavigate();
    const { ingresar, token, programa, configurarSede, user } = useAuth();
    const [login, setLogin] = useState('');
    const [sede, setSede] = useState('');
    const [password, setPassword] = useState(''); 
    const [errores, setErrores] = useState('');
    const [sedes, setSedes] = useState([]);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [showSelectSede, setShowSelectSede] = useState(false);
    useEffect(() => {
      const handleResize = () => setIsMobile(window.innerWidth <= 768);
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);
    async function ConsultarSedesActivas (programaSecretaria, tokenLog) {
        const url = `/sedesactivas/${programaSecretaria}`;
        try {
            const response = await apiService.get(url, tokenLog)
            setSedes(response.data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    async function configurarSedeProfesional (sede) {
        const url = `/users/configurarsedeprofesional`;
        const obj = { idUser: user, sede: sede, programa: programa };
        try {
            const response = await apiService.post(url, obj, token)
            if(response.status === 200){
                await configurarSede(sede);
            }else{
              Mensaje('Login', JSON.stringify(response.data));
            }
        } catch (error) {
          Mensaje('Login', JSON.stringify(error.response.data));
          console.error('Error fetching data:', error);
        }
    };
    
    async function irAPaginaPrincipal(programa) {
      if(programa === '2'){
        navigate('/reincorporados');
      }else{
        navigate('/dashboard');
      }
    }
    useEffect(() => {
      if(sedes.length >= 1){
        setShowSelectSede(true);
      }
    }, [sedes]);
    const handleLogin = async (e) => { 
        e.preventDefault();
        showSpinner(true);
        await ingresar(login, password)
        .then(async (data) => {
          if(data.token){
            await ConsultarSedesActivas(data.user.programa, data.token.token);
          }
        })
        .catch((error) => {
          if(error.status === 422){
              const respuestalista = error.response.data.errors.map(error => `${error.field}-${error.message},`).join('');
              Mensaje('Login fallo', `${respuestalista}`);
          } else if(error.status === 404){
              Mensaje('Login fallo', 'Error en el servidor, por favor intente nuevamente más tarde');
          } else if(error.status === 409){
              Mensaje('Login fallo', error.response.data);
          }else {
              Mensaje('Login fallo', `Error al guardar ${error}`);
          }
          setErrores('Datos incorrectos ');
        })
        .finally(() => {
          showSpinner(false);
        });
    }
    const handleSede = async (e) => { 
        e.preventDefault();
        if (!sede || sede === '0') {
            setErrores('Por favor seleccione una sede válida.');
            return;
        }
        showSpinner(true);
        try 
        { 
            await configurarSedeProfesional(sede);
            await irAPaginaPrincipal(programa);
        } catch (error) 
        { 
            Mensaje('Login', JSON.stringify(error.response.data));
            setErrores('Datos incorrectos ');
        } finally {
            showSpinner(false);
        };
    }
    const showSpinner = (estado) => { 
        if(estado){
            Logeando.fire({ 
                title: "Validando ingreso...", 
                html: <LoadingSpinner />, 
                showConfirmButton: false, 
                allowOutsideClick: false, });         
        }else{
            Logeando.close();
        }
    };
    return (
      <div 
        style={{ 
          display: 'flex', 
          flexDirection: isMobile ? 'column' : 'row', 
          height: '100vh', 
          alignItems: isMobile ? 'center' : 'stretch', 
          justifyContent: isMobile ? 'center' : 'stretch' }}>
        <FormImage>
          <div className='row' style={{ height: '45vh', margin: 0 }}>
            <div className='col-12 col-md-4'
              style={{
                flex: isMobile ? 'none' : 0.3,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: isMobile ? '100%' : 'auto',
                background: 'rgba(255,255,255,0.4)', // 80% transparency
                zIndex: 2,
                height: '100vh',
              }}
            > 
              <Row style={{ width: '100%', alignItems: 'center', justifyContent: 'center', margin: 0 }}>
                <div className='col-12' style={{ textAlign: 'center', width: '100%' }}>
                  <img
                    src="../dist/img/logo_login.png"
                    alt="Logo"
                    style={{
                      width: '80%',
                      maxWidth: '500px', // Optional: limit max size
                      height: 'auto',
                      display: 'block',
                      margin: '0 auto'
                    }}
                  />
                  <div style={{ fontWeight: 'bold', fontSize: '1.2rem', color: '#333', marginTop: '10px' }}>
                    Secretaria de Paz y DDHH
                  </div>
                  <div style={{ fontSize: '1rem', color: '#555', marginTop: '5px' }}>
                    Subsecretaría de Justicia Transicional y Restaurativa
                  </div>
                </div>
                <div className='col-12' style={{ textAlign: 'center', width: '100%', marginTop: '20px' }}>
                  <form onSubmit={handleLogin} style={{ 
                      display: 'flex', 
                      flexDirection: 'column', 
                      alignItems: 'center', 
                      justifyContent: 'center', 
                      height: '100%' }}>
                      <LoginBoxMsg>Ingresar a VIDAR</LoginBoxMsg>
                      {errores && <p style={{ color: 'red' }}>{errores}</p>}
                      <InputGroup>
                        <StyledInput
                          type="text"
                          value={login}
                          onChange={(e) => setLogin(e.target.value)}
                          required
                          placeholder="Usuario"
                          disabled={showSelectSede}
                        />
                      </InputGroup>
                      <InputGroup>
                        <StyledInput
                          type="password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          required
                          placeholder="Contraseña"
                          disabled={showSelectSede}
                        />
                      </InputGroup>
                      {!showSelectSede && <Row>
                          <Col md={12}>
                            <Button type="submit">VALIDAR ACCESO</Button>
                          </Col>
                      </Row>}
                    </form>
                    {showSelectSede && <form onSubmit={handleSede}>
                      <FormGroup>
                        <StyledSelect
                          value={sede}
                          onChange={(e) => setSede(e.target.value)}
                          id="sede"
                        >
                          <option value="0">Seleccionar sede</option>
                          {sedes.map((e) => (
                            <option value={e.id} key={e.id}>
                              {e.sedNombre}
                            </option>
                          ))}
                        </StyledSelect>
                      </FormGroup>
                      <Row>
                          <Col md={12}>
                            <Button type='submit'>Ingresar</Button>
                          </Col>
                      </Row>
                    </form>}
                </div>
                <LockscreenFooter className='col-12' style={{ textAlign: 'center', width: '100%', marginTop: '20px' }}>
                  Copyright &copy; 2025{' '}
                  <b>
                    <ButtonLink>Equipo de V&iacute;ctimas, Alcald&iacute;a de Medell&iacute;n</ButtonLink>
                  </b>
                  <br />
                  All rights reserved
                </LockscreenFooter>
              </Row>              
            </div>
          </div>          
        </FormImage>
      </div>
    )
  }